export function isToday(dueDate: Date): boolean {
    const today = new Date();
    const date = new Date(dueDate);
    return date.toDateString() === today.toDateString();
}

export function isTomorrow(dueDate: Date): boolean {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const date = new Date(dueDate);
    return date.toDateString() === tomorrow.toDateString();
}

//Should return for any days Monday-Sunday for same week as today that don't overlap with today or tomorrow
export function isThisWeek(dueDate: Date): boolean {
    const today = new Date();
    const date = new Date(dueDate);

    // Get the current week's Monday
    const currentMonday = new Date(today);
    currentMonday.setDate(today.getDate() - today.getDay() + 2);

    // Get the current week's Sunday
    const currentSunday = new Date(currentMonday);
    currentSunday.setDate(currentMonday.getDate() + 6);

    // Check if the date is within this week but not today or tomorrow
    return date > today && date > new Date(today.setDate(today.getDate() + 1)) &&
        date >= currentMonday && date <= currentSunday;
}

//Should return for any days Monday-Sunday for week after isThisWeek
export function isNextWeek(dueDate: Date): boolean {
    const today = new Date();
    const date = new Date(dueDate);

    // Get the current week's Monday
    const currentMonday = new Date(today);
    currentMonday.setDate(today.getDate() - today.getDay() + 1);

    // Get the next week's Monday
    const nextMonday = new Date(currentMonday);
    nextMonday.setDate(currentMonday.getDate() + 7);

    // Get the next week's Sunday
    const nextSunday = new Date(nextMonday);
    nextSunday.setDate(nextMonday.getDate() + 6);

    // Check if the date falls within the next week
    return date >= nextMonday && date <= nextSunday;
}

export function isThisMonth(date: Date): boolean {
    const today = new Date();
    return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth();
}

export function isWithinNumDays(date: Date, days: number): boolean {
    const today = new Date();
    const timeDifference = today.getTime() - date.getTime();
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    return daysDifference <= days && daysDifference >= 0;
}


